export enum KeyboardAnimationTransition {
  Hide = 'visible => hidden',
  Show = 'void => visible',
}
